<template>
    <div>
      <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
      <div class="loader" v-if="this.isLoading"></div>   
      <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div> 
  
          <!--begin::navbar-->
          <navbar-component></navbar-component>
          <!--end::navbar-->
  
        <div class="page-wrapper">
  
          <!--begin::content-->
          <div class="page-content">
            <div class="row">
                <div>
                    <h4 class="mb-12 mb-md-0"></h4>
                </div>
  
                <div class="col-lg-12 col-xl-12 stretch-card">
                    <div class="card">
                    <div class="card-header">
                        <h4 style="margin-right: 5px" class="float-start">{{ $t("cml_wms_code") }}</h4>
                        
                        
                        <button
                        v-if="permision_role.method_read"
                        class="btn btn-success float-end btn-xs"
                        style="margin-right: 5px"
                        @click.prevent="downloadData()"
                        >
                        <i class="link-icon" data-feather="download"></i>
                        {{ $t("downloadData") }} .xlsx
                        </button>
                    </div>
    
                    <div class="card-body">
                        <vue-good-table
                        title="list-billing-cml-wms-code"
                        mode="remote"
                        @on-page-change="onPageChange"
                        @on-sort-change="onSortChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        :totalRows="totalRecords"
                        :line-numbers="true"
                        :isLoading.sync="isLoading"
                        :pagination-options="{
                            enabled: true,
                            perPageDropdown: [10, 50, 100, 1000, 10000],
                            dropdownAllowAll: false,
                        }"
                        :rows="rows"
                        :columns="columns"
                        
                        >
    
                        <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field == 'actions'">
                                
                                <a
                                    href="#"
                                    v-if="permision_role.method_read"
                                    title="Detail"
                                    @click.prevent="detailData(props.index, props.row)"
                                >
                                    <i class="mdi mdi-eye" style="font-size:16px"></i>
                                    
                                </a>
                                
                            </span>
                            <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                            </span>
                        </template>
                        </vue-good-table>
                    </div>
                    </div>
                </div>

            </div>
          </div>
          <!--end::content-->
  
          <!--begin::footer-->
          <footer-component></footer-component>
          <!--end::footer-->
  
  
          <!--begin::modal-->
  
  
          <modal name="detailBillingBmCode" :draggable="false" :scrollable="true" :height="'auto'">
            <div class="modal fade show" tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true" role="dialog">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
      
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">{{this.$t("detail_wms_code")}}</h5>
              <button type="button" class="btn-close" aria-label="btn-close" @click.prevent="removeModals()"></button>
            </div>
  
            <div class="modal-body">
                
              
                <div class="mb-3">
                    <label for="idWmsCode" class="form-label">{{this.$t("idWmsCode")}}:</label>
                    <input type="text" class="form-control" id="idWmsCode" :placeholder="$t('idWmsCode')" v-model="forms.idWmsCode" disabled/>
                    <div v-if="errors.idWmsCode">
                    <div
                        v-for="error in errors.idWmsCode"
                        :key="error"
                        class="alert alert-primary"
                        role="alert"
                    >
                        <i data-feather="alert-circle"></i>
                        {{ error }}
                    </div>
                    </div>
                </div>
  
                <div class="mb-3">
                    <label for="warehouseId" class="form-label">{{this.$t("warehouseId_txt")}}:</label>
                    <input type="text" class="form-control" id="warehouseId" :placeholder="$t('warehouseId_txt')" v-model="forms.warehouseId" disabled/>
                    <div v-if="errors.warehouseId">
                    <div
                        v-for="error in errors.warehouseId"
                        :key="error"
                        class="alert alert-primary"
                        role="alert"
                    >
                        <i data-feather="alert-circle"></i>
                        {{ error }}
                    </div>
                    </div>
                </div>
  
                <div class="mb-3">
                    <label for="customerId" class="form-label">{{this.$t("customerId")}}:</label>
                    <input type="text" class="form-control" id="customerId" :placeholder="$t('customerId')" v-model="forms.customerId" disabled/>
                    <div v-if="errors.customerId">
                        <div
                        v-for="error in errors.customerId"
                        :key="error"
                        class="alert alert-primary"
                        role="alert"
                        >
                        <i data-feather="alert-circle"></i>
                        {{ error }}
                        </div>
                    </div>
                </div>
  
                <div class="mb-3">
                    <label for="category" class="form-label">{{this.$t("category")}}:</label>
                    <input type="text" class="form-control" id="category" :placeholder="$t('category')" v-model="forms.category" disabled/>
                    <div v-if="errors.category">
                    <div
                        v-for="error in errors.category"
                        :key="error"
                        class="alert alert-primary"
                        role="alert"
                    >
                        <i data-feather="alert-circle"></i>
                        {{ error }}
                    </div>
                    </div>
                </div>
  
                <div class="mb-3">
                    <label for="codeType" class="form-label">{{this.$t("codeType")}}:</label>
                    <input type="text" class="form-control" id="codeType" :placeholder="$t('codeType')" v-model="forms.codeType" disabled/>
                    
                </div>
  
                <div class="mb-3">
                    <label for="codeId" class="form-label">{{this.$t("codeId")}}:</label>
                    <input type="text" class="form-control" id="codeId" :placeholder="$t('codeId')" v-model="forms.codeId" disabled/>
                    
                </div>
  
                <div class="mb-3">
                    <label for="codeDesc" class="form-label">{{this.$t("codeDesc")}}:</label>
                    <input type="text" class="form-control" id="codeDesc" :placeholder="$t('codeDesc')" v-model="forms.codeDesc" disabled/>
                    
                </div>
                
                <div class="mb-3">
                    <label for="showSeq" class="form-label">{{this.$t("showSeq")}}:</label>
                    <input type="text" class="form-control" id="showSeq" :placeholder="$t('showSeq')" v-model="forms.showSeq" disabled/>
                    
                </div>
            
                <div class="mb-3">
                    <label for="outerCode" class="form-label">{{this.$t("outerCode")}}:</label>
                    <input type="text" class="form-control" id="outerCode" :placeholder="$t('outerCode')" v-model="forms.outerCode" disabled/>
                    
                </div>


                
                <div class="mb-3">
                    <label for="activeFlag" class="form-label">{{this.$t("activeFlag_txt")}}:</label>
                    <input type="text" class="form-control" id="activeFlag" :placeholder="$t('activeFlag_txt')" v-model="forms.activeFlag" disabled/>
                    
                </div>

                
                <div class="mb-3">
                    <label for="defaultFlag" class="form-label">{{this.$t("defaultFlag")}}:</label>
                    <input type="text" class="form-control" id="defaultFlag" :placeholder="$t('defaultFlag')" v-model="forms.defaultFlag" disabled/>
                    
                </div>

                
                
                <div class="mb-3">
                    <label for="udf01" class="form-label">{{this.$t("udf01")}}:</label>
                    <input type="text" class="form-control" id="udf01" :placeholder="$t('udf01')" v-model="forms.udf01" disabled/>
                    
                </div>

                
                
                <div class="mb-3">
                    <label for="udf02" class="form-label">{{this.$t("udf02")}}:</label>
                    <input type="text" class="form-control" id="udf02" :placeholder="$t('udf02')" v-model="forms.udf02" disabled/>
                    
                </div>

                
                
                <div class="mb-3">
                    <label for="udf03" class="form-label">{{this.$t("udf03")}}:</label>
                    <input type="text" class="form-control" id="udf03" :placeholder="$t('udf03')" v-model="forms.udf03" disabled/>
                    
                </div>

                
                
                <div class="mb-3">
                    <label for="udf04" class="form-label">{{this.$t("udf04")}}:</label>
                    <input type="text" class="form-control" id="udf04" :placeholder="$t('udf04')" v-model="forms.udf04" disabled/>
                    
                </div>

                
                
                <div class="mb-3">
                    <label for="udf05" class="form-label">{{this.$t("udf05")}}:</label>
                    <input type="text" class="form-control" id="udf05" :placeholder="$t('udf05')" v-model="forms.udf05" disabled/>
                    
                </div>

                

                <div class="mb-3">
                    <label for="addWho" class="form-label">{{this.$t("create_by_txt")}}:</label>
                    <input type="text" class="form-control" id="addwho" :placeholder="$t('create_by_txt')" v-model="forms.addWho" disabled/>
                    <div v-if="errors.addWho">
                    <div
                        v-for="error in errors.addWho"
                        :key="error"
                        class="alert alert-primary"
                        role="alert"
                    >
                        <i data-feather="alert-circle"></i>
                        {{ error }}
                    </div>
                    </div>
                </div>
        
                <div class="mb-3">
                    <label for="editWho" class="form-label">{{this.$t("update_by_txt")}}:</label>
                    <input type="text" class="form-control" id="editWho" :placeholder="$t('update_by_txt')" v-model="forms.editWho" disabled/>
                    <div v-if="errors.editWho">
                    <div
                        v-for="error in errors.editWho"
                        :key="error"
                        class="alert alert-primary"
                        role="alert"
                    >
                        <i data-feather="alert-circle"></i>
                        {{ error }}
                    </div>
                    </div>
                </div>
                    
                    
                <div class="mb-3">
                    <label for="addDate" class="form-label">{{this.$t("create_at_txt")}}:</label>
                    <input type="text" class="form-control" id="addDate" :placeholder="$t('create_at_txt')" v-model="forms.addDate" disabled/>
                    <div v-if="errors.addDate">
                    <div
                        v-for="error in errors.addDate"
                        :key="error"
                        class="alert alert-primary"
                        role="alert"
                    >
                        <i data-feather="alert-circle"></i>
                        {{ error }}
                    </div>
                    </div>
                </div>
                    
                <div class="mb-3">
                    <label for="editDate" class="form-label">{{this.$t("update_at_txt")}}:</label>
                    <input type="text" class="form-control" id="editDate" :placeholder="$t('update_at_txt')" v-model="forms.editDate" disabled/>
                    <div v-if="errors.editDate">
                    <div
                        v-for="error in errors.editDate"
                        :key="error"
                        class="alert alert-primary"
                        role="alert"
                    >
                        <i data-feather="alert-circle"></i>
                        {{ error }}
                    </div>
                    </div>
                </div>
              
  
            </div>
  
            <div class="modal-footer justify-content-between">
              <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{this.$t("close_txt")}}</button>
            </div>
   
                </div>
              </div>
            </div>
          </modal>
          <!--end::modal-->
  
  
          
        </div>


      </div>
    </div>
</template>
  
  <script>
  import navbarComponent from "@/components/_partials/_navbar";
  import footerComponent from "@/components/_partials/_footer";
  
  export default {
    name: "BmWmsCodeIndex",
    components: {
      "navbar-component": navbarComponent,
      "footer-component": footerComponent,
    },
    data() {
      return {
        maxToasts: 100,
        position: "up right",
        closeBtn: true,
        isLoading: false,
        errors: [],
        idCodeLkups:[],
        forms:{idWmsCode:"",
        warehouseId:"",
        customerId:"",
        codeType:"",
        category:"",
        codeId:"",
        codeDesc:"",
        showSeq:"",
        outerCode:"",
        activeFlag:"",
        defaultFlag:"",
        udf01:"",
        udf02:"",
        udf03:"",
        udf04:"",
        udf05:"",
        addWho:"",
        editWho:"",
        addDate:"",
        editDate:"",},
        permision_role:[],
        langs: ["id", "en"],
        detailUser: [],
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: {
            field: "",
            type: "",
          },
          page: 1,
          per_page: 10,
        },
        columns: [
            {
            label: this.$t("action_txt"),
            field: "actions",
            sortable: false,
            thClass: 'text-center',
          },
          {
            label: this.$t("idWmsCode"),
            field: "idWmsCode",
            thClass: 'text-center',
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: this.$t("idWmsCode"), // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },
          {
            label: this.$t("warehouseId_txt"),
            field: "warehouseId",
            thClass: 'text-center',
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: this.$t("warehouseId_txt"), // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },
          {
            label: this.$t("customerId"),
            field: "customerId",
            thClass: 'text-center',
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: this.$t("customerId"), // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },
          {
            label: this.$t("category"),
            field: "category",
            thClass: 'text-center',
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: this.$t("category"), // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },
          {
            label: this.$t("codeType"),
            field: "codeType",
            thClass: 'text-center',
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: this.$t("codeType"), // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },
          {
            label: this.$t("codeId"),
            field: "codeId",
            thClass: 'text-center',
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: this.$t("codeId"), // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },
          {
            label: this.$t("codeDesc"),
            field: "codeDesc",
            thClass: 'text-center',
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: this.$t("codeDesc"), // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              trigger: "enter", //only trigger on enter not on keyup
            },
          },
        ],
        rows: [],
      };
    },
    watch: {},
    methods: {
  
  
      success2(msg) {
        let pesan = "";
        msg.forEach((item) => {
          pesan = pesan + "<p>* " + item + "</p>";
        });
  
        this.$swal({
          icon: 'info',
          backdrop: true,
          title: "Information",
          html: pesan,
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false
        })
  
  
      },
      
  
  
      removeModals(){
        
        this.forms.idWmsCode = "";
        this.forms.warehouseId = "";
        this.forms.customerId = "";
        this.forms.codeType = "";
        this.forms.category = "";
        this.forms.codeId = "";
        this.forms.codeDesc = "";
        this.forms.showSeq = "";
        this.forms.outerCode = "";
        this.forms.activeFlag = "";
        this.forms.defaultFlag = "";
        this.forms.udf01 = "";
        this.forms.udf02 = "";
        this.forms.udf03 = "";
        this.forms.udf04 = "";
        this.forms.udf05 = "";
        this.forms.addWho = "";
        this.forms.editWho = "";
        this.forms.addDate = "";
        this.forms.editDate = "";
        this.errors                     = []
        this.$modal.hide('detailBillingBmCode')
  
      },
  
      downloadData() {
        const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/bm-wms-code-cml";
        var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
        var file_name = "download_" + CurrentDate + ".xlsx";
  
        //var columnFilters = this.serverParams.columnFilters;
  
  
        return this.$http
          .get(
            baseURI +
              `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&warehouseId=${this.serverParams.columnFilters.warehouseId}&idWmsCode=${this.serverParams.columnFilters.idWmsCode}&customerId=${this.serverParams.columnFilters.customerId}&category=${this.serverParams.columnFilters.category}&codeType=${this.serverParams.columnFilters.codeType}&codeId=${this.serverParams.columnFilters.codeId}&codeDesc=${this.serverParams.columnFilters.codeDesc}&download=download`,
            {
              responseType: "blob",
            }
          )
          .then((response) => {
           
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
  
            fileLink.href = fileURL;
            fileLink.setAttribute("download", file_name);
            document.body.appendChild(fileLink);
            fileLink.click();
            this.fade(false);
          });
      },
   
   
      detailData(index, row) {
        this.forms.idWmsCode = row.idWmsCode;
        this.forms.warehouseId =  row.warehouseId;
        this.forms.customerId = row.customerId;
        this.forms.codeType = row.codeType;
        this.forms.category = row.category;
        this.forms.codeId = row.codeId;
        this.forms.codeDesc = row.codeDesc;
        this.forms.showSeq = row.showSeq;
        this.forms.outerCode = row.outerCode;
        this.forms.activeFlag = row.activeFlag;
        this.forms.defaultFlag = row.defaultFlag;
        this.forms.udf01 = row.udf01;
        this.forms.udf02 = row.udf02;
        this.forms.udf03 = row.udf03;
        this.forms.udf04 = row.udf04;
        this.forms.udf05 = row.udf05;
        this.forms.addWho = row.addWho;
        this.forms.editWho = row.editWho;
        this.forms.addDate = row.addDate;
        this.forms.editDate = row.editDate;
        this.errors                     = []
        this.$modal.show('detailBillingBmCode')
      },
  
  
  
      // load items is what brings back the rows from server
      loadItems() {
        const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/bm-wms-code-cml";
        this.isLoading = true;
        //var columnFilters = this.serverParams.columnFilters;
  
  
        return this.$http
          .get(
             baseURI +
             `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&idWmsCode=${this.serverParams.columnFilters.idWmsCode}&warehouseId=${this.serverParams.columnFilters.warehouseId}&customerId=${this.serverParams.columnFilters.customerId}&category=${this.serverParams.columnFilters.category}&codeType=${this.serverParams.columnFilters.codeType}&codeId=${this.serverParams.columnFilters.codeId}&codeDesc=${this.serverParams.columnFilters.codeDesc}`,
            { timeout: 60000 })
          .then((response) => {
            this.isLoading = false;
            this.rows = response.data.datas.data;
            this.totalRecords = response.data.datas.total;
          }).catch((error) => {
                this.loading();
                  
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }

              });
      },
  
      logout(){

          const baseURI = this.$settings.endPoint + "user/logout";
          this.$http.get(baseURI, { timeout: 60000 }).then((response) => {
              
          console.log(response);

          });

          this.$logoutUser();
          window.location.href = '/';
      },

      updateParams(newProps) {
        this.serverParams = Object.assign({}, this.serverParams, newProps);
        this.loadItems();
      },
  
      onColumnFilter(params) {
        this.updateParams(params);
      },
  
      onPageChange(params) {
        this.updateParams({ page: params.currentPage });
      },
  
      onSortChange(params) {
        this.updateParams({
          sort: {
            type: params[0].type,
            field: params[0].field,
          },
        });
      },
  
      onPerPageChange(params) {
        this.updateParams({ per_page: params.currentPerPage });
      },
  
      resultError(data) {
        var count = Object.keys(data).length;
        for (var x = 0; x < count; x++) {
          var nameOb = Object.keys(data)[x];
          var objectData = data[nameOb];
          for (var y = 0; y < objectData.length; y++) {
            this.error(objectData[y]);
          }
        }
      },
  
      success(kata) {
        const Toast = this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });
        Toast.fire({
          icon: "success",
          title: kata,
        });
      },
  
      error(kata) {
        const Toast = this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });
        Toast.fire({
          icon: "error",
          title: kata,
        });
      },
  
      fade(sType) {
        this.isLoading = sType;
      },
  
      loading() {
        this.fade(true);
        setTimeout(() => {
          this.isLoading = false;
        }, 1000); // hide the message after 3 seconds
      },
  
      fetchIt() {
        const userDatas     = this.$getUserInfo();
        this.detailUser     = userDatas.sub;
        // this.permision_role = userDatas.sub.permision_role;
        let rolePermision = [];
        userDatas.sub.permision_role.forEach(function(permision){
          if(permision.permission.controller == 'BmWmsCodeController'){
            rolePermision = permision;
            // console.log(permision);
          }
        });
  
        if(!rolePermision.method_read){
          this.$router.push("/authorized-error");
        }
        this.permision_role = rolePermision;
  
      },
   
    },
    events: {},
    created: function () {},
    mounted() {
      this.fetchIt();
      this.loading();
    },
  };
  </script>
  <style scoped>
  </style>